module.exports = __webpack_public_path__ + "img/physioswiss.e19ccbeb.svg";